<template>
    <v-snackbar
        v-model="showSnackbar"
        :color="options.color"
        :top="options.top"
        :bottom="options.bottom"
        :left="options.left"
        :right="options.right"
        :multi-line="options.multiline"
        :timeout="options.timeout"
        :vertical="options.vertical"
        :absolute="options.absolute"
    >
        {{ text }}
        <v-btn dark text @click="showSnackbar = false">Close</v-btn>
    </v-snackbar>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

const defaultOptions = {
    color: 'secondary',
    timeout: 5000,
    top: false,
    bottom: true,
    left: false,
    right: true,
    multiline: false,
    vertical: false,
    absolute: false
}

export default {
    name: 'snackbar',
    data: () => ({
        showSnackbar: false,
        text: '',
        options: {}
    }),
    methods: {
        show( text, options ){
            console.log( 'show snackbar', text, options )
            this.text = text
            this.options = Object.assign( defaultOptions, options )
            this.showSnackbar = true
        }
    },
    created(){
        this.options = defaultOptions
        Object.freeze( defaultOptions )
    }
}
</script>
